module.exports = __webpack_public_path__ + "img/compliance_checked.1b9e2f53.svg";